import React from "react";
import { Link } from "react-router-dom";
import { heroContent } from "../mock";
import { useModeContext } from "../contexts/ModeContext";

const Datenschutz = () => {
  const { activeMode } = useModeContext();
  const c = heroContent.colors;

  return (
    <main className={`min-h-screen ${activeMode === 0 ? "bg-white" : "bg-neutral-950"}`}>
      {/* Header Spacer */}
      <div className="h-20"></div>
      
      <div className="mx-auto max-w-4xl px-6 py-12">
        <nav aria-label="Breadcrumb" className="mb-8">
          <ol className={`flex items-center space-x-2 text-sm ${activeMode === 0 ? "text-neutral-600" : "text-neutral-400"}`}>
            <li>
              <Link to="/" className={`hover:${activeMode === 0 ? "text-neutral-900" : "text-neutral-200"} transition-colors`}>
                Startseite
              </Link>
            </li>
            <li aria-hidden="true">/</li>
            <li aria-current="page" className={activeMode === 0 ? "text-neutral-900" : "text-neutral-200"}>Datenschutzerklärung</li>
          </ol>
        </nav>

        <h1 className="text-3xl font-bold mb-8" style={{ color: c.heading }}>
          Datenschutzerklärung
        </h1>

        <div className={`prose prose-neutral max-w-none ${activeMode === 1 ? "prose-invert" : ""}`}>
          <section aria-labelledby="allgemeine-hinweise-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="allgemeine-hinweise-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              1. Allgemeine Hinweise
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
              persönlich identifiziert werden können.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten 
              Datenschutzerklärung.
            </p>
          </section>

          <section aria-labelledby="verantwortlicher-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="verantwortlicher-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              2. Verantwortlicher
            </h2>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Verantwortlicher für die Datenverarbeitung auf dieser Website ist:<br /><br />
              <strong>Tom Oppenhäuser</strong><br />
              Im Andorf 12<br />
              56170 Bendorf<br />
              Deutschland<br /><br />
              E-Mail: mail@tom-oppenhaeuser.com
            </p>
          </section>

          <section aria-labelledby="datenerfassung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="datenerfassung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              3. Wie erfassen wir Ihre Daten?
            </h2>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>Datenerfassung durch Websitebesuch</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um 
              Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor 
              allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die 
              Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>
          </section>

          <section aria-labelledby="verwendung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="verwendung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              4. Wofür nutzen wir Ihre Daten?
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
              Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Daten aus Kontaktformularen werden ausschließlich zur Bearbeitung Ihrer Anfrage und für den Fall von 
              Anschlussfragen gespeichert und verarbeitet.
            </p>
          </section>

          <section aria-labelledby="rechte-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="rechte-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              5. Welche Rechte haben Sie bezüglich Ihrer Daten?
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer 
              gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, 
              Sperrung oder Löschung dieser Daten zu verlangen.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum 
              angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen 
              Aufsichtsbehörde zu.
            </p>
          </section>

          <section aria-labelledby="hosting-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="hosting-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              6. Hosting und Content Delivery Networks (CDN)
            </h2>
            <h3 className={`text-lg font-medium mb-3 ${activeMode === 1 ? "text-neutral-200" : ""}`}>Externes Hosting</h3>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, 
              die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Das Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden 
              Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten 
              Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
          </section>

          <section aria-labelledby="server-log-files-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="server-log-files-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              7. Server-Log-Dateien
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, 
              die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className={`list-disc list-inside mb-4 space-y-1 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser 
              Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes 
              Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website.
            </p>
          </section>

          <section aria-labelledby="kontaktformular-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="kontaktformular-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              8. Kontaktformular
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
              inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall 
              von Anschlussfragen bei uns gespeichert.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung der in das Kontaktformular 
              eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). 
              Sie können diese Einwilligung jederzeit widerrufen.
            </p>
          </section>

          <section aria-labelledby="speicherdauer-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="speicherdauer-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              9. Speicherdauer
            </h2>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben 
              Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein 
              berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, 
              werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung 
              Ihrer personenbezogenen Daten haben.
            </p>
          </section>

          <section aria-labelledby="ssl-verschluesselung-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="ssl-verschluesselung-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              10. SSL- bzw. TLS-Verschlüsselung
            </h2>
            <p className={`mb-4 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum 
              Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. 
              TLS-Verschlüsselung.
            </p>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf 
              "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- bzw. TLS-Verschlüsselung 
              aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
            </p>
          </section>

          <section aria-labelledby="aenderungen-heading" className={`${activeMode === 1 ? "bg-neutral-900 text-neutral-200" : ""} p-4 rounded-lg mb-6`}>
            <h2 id="aenderungen-heading" className={`text-xl font-semibold mb-4 ${activeMode === 1 ? "text-neutral-100" : ""}`}>
              11. Änderungen dieser Datenschutzerklärung
            </h2>
            <p className={`mb-6 ${activeMode === 1 ? "text-neutral-300" : ""}`}>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen 
              Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. 
              Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
            </p>
          </section>
        </div>

        <div className={`mt-12 pt-8 border-t ${activeMode === 1 ? "border-neutral-800" : "border-neutral-200"}`}>
          <Link 
            to="/" 
            className={`inline-flex items-center ${activeMode === 1 ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-800"} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded`}
          >
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </main>
  );
};

export default Datenschutz;
